import React from "react";
import {Helmet} from "react-helmet-async";
import "../../styles/frontend/contact/style.css";
import GreenEnergySection from '../../components/GreenEnergySection/GreenEnergySection';

const ContactPage = () => {

    return (
        <>
            <Helmet>
                {/* Seiten-Titel */}
                <title>Kontakt - Cloudtal</title>

                {/* Meta-Informationen */}
                <meta
                    name="description"
                    content="Kontaktieren Sie Cloudtal für Fragen, Unterstützung oder individuelle Cloud-Lösungen. Unser Team steht Ihnen gerne zur Verfügung."
                />
                <meta
                    name="keywords"
                    content="Kontakt, Cloud-Dienste, Support, Anfrage, Beratung, Cloudtal"
                />
                <meta name="author" content="Cloudtal Team" />

                {/* Open Graph für Social Media */}
                <meta property="og:title" content="Kontakt - Cloudtal" />
                <meta
                    property="og:description"
                    content="Haben Sie Fragen zu unseren Cloud-Diensten? Kontaktieren Sie Cloudtal und wir helfen Ihnen gerne weiter!"
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.cloudtal.de/contact" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://www.cloudtal.de/contact" />
            </Helmet>
            <main className="flex-1">
                {/* Hero Section */}
                <section className="relative w-full min-h-screen bg-black text-white flex items-center justify-center overflow-hidden">
                    <div className="container px-4 md:px-6 text-center">
                        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl text-white">
                            Kontaktieren Sie uns
                        </h1>
                        <p className="mx-auto max-w-[700px] text-zinc-400 md:text-xl">
                            Haben Sie Fragen oder benötigen Sie Unterstützung? Füllen Sie das Formular aus und wir werden uns schnellstmöglich bei Ihnen melden.
                        </p>
                    </div>
                </section>

                {/* Kontaktbereich */}
                <section className="w-full py-12 md:py-24 lg:py-32 bg-zinc-900 text-white">
                    <div className="container mx-auto px-4 md:px-6 text-center">
                        <div className="max-w-2xl mx-auto">
                            <h2 className="text-3xl md:text-4xl font-bold mb-6">Kontaktieren Sie uns</h2>
                            <p className="text-lg md:text-xl mb-6 text-gray-300">
                                Haben Sie Fragen oder Anregungen? Zögern Sie nicht, uns zu kontaktieren.
                                Schreiben Sie uns eine E-Mail und wir melden uns schnellstmöglich bei Ihnen.
                            </p>
                            <p className="text-lg md:text-xl font-semibold">
                                <a href="mailto:info@cloudtal.de" className="text-green-400 hover:underline">
                                    info@cloudtal.de
                                </a>
                            </p>
                        </div>
                    </div>
                </section>

                {/* Green Energy Section */}
                <GreenEnergySection />
            </main>
        </>
    );
};

export default ContactPage;
